module.exports = __webpack_public_path__ + "static/media/defi-illustration-mobile.9ec98090.svg";